import classNames from 'classnames'
import {Shape} from 'quickstart/components/layout/Shape'
import {withClassNames} from 'quickstart/theme'
import type {ComponentProps} from 'react'
import {Text} from '../Text'
import S from './styles.module.css'

export const Cover = withClassNames(S.cover)(Shape)

export const Body = withClassNames(S.body)('div')

export const Footer = withClassNames(S.footer)('div')

export const Meta = (props: ComponentProps<typeof Text>) => (
  <Text
    variant="cardMeta"
    prose
    {...props}
    className={classNames(S.meta, props.className)}
  />
)

export const Heading = (props: ComponentProps<typeof Text>) => (
  <Text
    variant="cardHead"
    prose
    {...props}
    className={classNames(S.heading, props.className)}
  />
)

export const CallToAction = (props: ComponentProps<typeof Text>) => (
  <Text
    variant="cardCta"
    {...props}
    className={classNames(S['call-to-action'], props.className)}
  />
)
